import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	AppTabs,
	Edit,
	Create,
	Crud,
	trans
} from '@/router/index'

import TimecardsSettings from '@/components/modules/timecards/settings/TimecardsSettings'


export const timecards = [
	{ 
		path: '/timecards',
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/timecards/',
					text: 'Timecard',
					module: 'timecards'
				},						
			],
		},
		children: [
			{
				path: '/timecards/',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'timecards', next) },
				component: Crud,
				meta: {
					title: trans('timecard')
				},				
				props: {
					modelDef: 'timecards',
					actionIcon: 'alarm',
					title: 'Timecard',
					styleClass: 'mb-offset',
					crudDialog: true
				}
			},		
		],
	},
	{ 
		path: '/timecards/create',
		name: 'timecards-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'timecards',
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/timecards/:id/edit',
		name: 'timecards-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'timecards',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/settingstimecards/',
		name: 'settingstimecards',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingstimecards',
					text: 'Timecard',
				},
			],
		},
		children: [
			{
				path: '/settingstimecards/',
				beforeEnter: ifAuthenticatedOnline,
				component: TimecardsSettings,
			},		
		],
	},
]